var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckboxCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.207 7.293a1 1 0 0 1 0 1.414L10.5 18.414l-6.707-6.707a1 1 0 1 1 1.414-1.414l5.293 5.293 8.293-8.293a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
export default SvgIconCheckboxCheckmark;